import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, LinkButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const MoreInformationNeededWarningWrapper = styled(Box)`
  position: relative;

  &::before {
    position: absolute;
    content: '';
    top: -4px;
    left: calc((100% / 3) / 2 - 10px);
    width: 20px;
    height: 20px;
    transform: rotateZ(45deg);
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.missingContainer};
  }
`;

interface Props extends BoxExtendedProps {
  fullName?: string;
  setIsAddPatientModalVisible?: (value: boolean) => void;
  setProviderFullName?: (value: string) => void;
}

const MoreInformationNeededWarning: React.FC<Props> = ({ fullName, setIsAddPatientModalVisible, setProviderFullName, ...props }) => {
  const { t } = useTranslation();

  const handleAddDetails = useCallback(() => {
    if (!fullName) return;
    setProviderFullName?.(fullName);
    setIsAddPatientModalVisible?.(true);
  }, [fullName, setProviderFullName, setIsAddPatientModalVisible]);

  return (
    <MoreInformationNeededWarningWrapper
      data-testId="more-information-needed-warning"
      pad="spacing16"
      background="missingContainer"
      round="container1Round"
      {...props}
    >
      <Text data-testId="more-information-needed-warning_title" weight={700}>
        {t('More information needed')}
      </Text>
      <Text data-testId="more-information-needed-warning_description" margin={{ top: 'spacing2' }}>
        {`We found ${fullName} on your receipt. Add details for ${fullName} to add them to your account and finish your claim.`}
      </Text>
      <Box margin={{ top: 'spacing2' }}>
        <LinkButton
          testId="more-information-needed-warning_add-details"
          onClick={handleAddDetails}
          linkInlineMode
        >
          {t('Add Details')}
        </LinkButton>
      </Box>
    </MoreInformationNeededWarningWrapper>
  );
};

export default MoreInformationNeededWarning;
